import React from 'react'
import { Link } from 'react-router-dom'

const Afip = () => {
   return (
      <>
         <div className="row mb-title">
            <div className="col s12 m12 l12 x12">
               <h5><b>ADMINISTRACIÓN FEDERAL DE INGRESOS PÚBLICOS</b></h5>
            </div>
         </div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución General 3487</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/210000-214999/212006/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución General 2192</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/200000-204999/200466/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Ley 27.401</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/295000-299999/296846/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución General 2812/10</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://biblioteca.afip.gob.ar/dcp/REAG01002812_2010_04_21" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución ANSES 130/10</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/160000-164999/164680/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución 2407/08</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/135000-139999/137353/norma.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
         <div className="row">
            <div className="col s6 m6 l6 x6">
               <h6>Resolución 1891/05</h6>
            </div>
            <div className="col s6 m6 l6 x6 pull-x7">
               <Link to="http://servicios.infoleg.gob.ar/infolegInternet/anexos/105000-109999/106744/texact.htm" target="_blank" className="btn waves-effect waves-light bg-latitud pulse" type="submit" name="action">Ver
                  <i className="material-icons right">send</i>
               </Link>
            </div>
         </div>
         <div className="divider light-blue darken-4 mb-divider"></div>
      </>
   )
}

export default Afip